import "./style.css"
import { RiLoader2Line } from "react-icons/ri"

function LoadingAnimation2() {
    return (
        <div id="custom-loader-2" className="flex-c-full">
            <RiLoader2Line />
        </div>
    );
}

export default LoadingAnimation2;